export const sortSigned = <
  T extends { signed: boolean; numberOfSignatures?: number },
>(
  a: T,
  b: T,
): -1 | 0 | 1 => {
  if (a.numberOfSignatures === b.numberOfSignatures) {
    if (a.signed > b.signed) return 1;
    if (a.signed < b.signed) return -1;
    return 0;
  }
  if (a.numberOfSignatures === undefined) return 1;
  if (b.numberOfSignatures === undefined) return -1;
  if (a.numberOfSignatures > b.numberOfSignatures) return 1;
  if (a.numberOfSignatures < b.numberOfSignatures) return -1;
  return 0;
};
